module.exports = __webpack_public_path__ + "img/TEXT.0793aa75.png";